import { PADDING_TO_SCROLL_TO_ELEMENT } from "scripts/constants";

const getElementTopBound = element => {
  const top = element.getBoundingClientRect().top + element.ownerDocument.defaultView.pageYOffset;
  return top;
};

const getPositionToScrollToElement = element => Math.max(0, getElementTopBound(element) - PADDING_TO_SCROLL_TO_ELEMENT);

export { getElementTopBound, getPositionToScrollToElement };